import { HOMEPAGE } from "utils/redirectConstants";

interface Props {
  transparent?: boolean;
  fluid?: boolean;
}

function Footer(props: Props) {
  return (
    <footer
      className={"footer" + (props.transparent !== undefined ? " footer-transparent" : "")}
      style={{ minHeight: "75px" }}
    >
      <div className={"container" + (props.fluid !== undefined ? "-fluid" : "")}>
        <p className="copyright pull-right">
          &copy; {new Date().getFullYear()}{" "}
          <a href={HOMEPAGE} target="_blank" rel="noreferrer">
            Trellis Corporation
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
